import { Badge, SvgComponent } from '@platform/ui'
import styles from './LockedActivityPart.module.scss'

export const LockedActivityPart = () => (
  <div className={styles.lockedActivityPart}>
    <Badge color="neutral">
      <SvgComponent name="LockBoldStroke" size="sm" />
    </Badge>
  </div>
)
